import axiosInstance from './axiosInstance';

export interface UpdateGameSourceResponse {
  success: boolean;
  message?: string;
  data?: {
    matched_count: number;
    modified_count: number;
    total_found: number;
    message: string;
  };
  error?: string;
}

export interface CalculateCategoriesResponse {
  success: boolean;
  data?: {
    categoryList: string[];
    stats: Record<string, number>;
    totalCategories: number;
    totalGames: number;
  };
  error?: string;
}

export interface FeishuTestResponse {
  success: boolean;
  data?: {
    code?: number;
    msg?: string;
    [key: string]: any;
  };
  message?: string;
  error?: string;
}

export interface AdSenseKeyStatusResponse {
  success: boolean;
  data?: {
    source: 'file' | 'db';
    hasDbConfig: boolean;
    encryptedValue: string;
    digest: string;
    canEdit: boolean;
  };
  error?: string;
}

export class MaintenanceApi {
  static async updateGameSource(): Promise<UpdateGameSourceResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'update_game_source'
    });
    return response.data.data;
  }
  
  static async calculateCategories(): Promise<CalculateCategoriesResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'calculate_categories'
    });
    return response.data.data;
  }

  static async sendFeishuTestMessage(text?: string): Promise<FeishuTestResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'feishu_test_message',
      text: text || ''
    });
    return response.data.data;
  }

  static async getAdSenseKeyStatus(): Promise<AdSenseKeyStatusResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'adsense_key_status'
    });
    return response.data.data;
  }

  static async setAdSenseKeySource(source: 'file' | 'db'): Promise<AdSenseKeyStatusResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'adsense_key_set_source',
      source
    });
    return response.data.data;
  }

  static async saveAdSenseKeyToDb(value: Record<string, any>): Promise<AdSenseKeyStatusResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'adsense_key_save_db',
      value
    });
    return response.data.data;
  }

  static async deleteAdSenseKeyDb(): Promise<AdSenseKeyStatusResponse> {
    const response = await axiosInstance.post('/cms/v1/maintenance', {
      action: 'adsense_key_delete_db'
    });
    return response.data.data;
  }
}
